import { render, staticRenderFns } from "./site-footer.vue?vue&type=template&id=70e5bb78&"
import script from "./site-footer.vue?vue&type=script&lang=js&"
export * from "./site-footer.vue?vue&type=script&lang=js&"
import style0 from "./site-footer.vue?vue&type=style&index=0&id=70e5bb78&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports